module.exports = __webpack_public_path__ + "img/jiayou1.b8e43859.png";